@if (showTrigger && tasksService.tasksLoaded) {
  <div
    class="add-chip-button"
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="taskMenu"
    (click)="$event.stopPropagation(); onMenuOpened()"
    (menuOpened)="onMenuOpened()">
    <ion-icon name="add" />
  </div>
}

@if (!showTrigger) {
  <div
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="taskMenu"
    (menuOpened)="onMenuOpened()"
    class="task-dropdown-hidden-trigger">
  </div>
}

<mat-menu #taskMenu="matMenu" class="task-dropdown-panel" (closed)="onMenuClosed()">
  <div class="task-dropdown-search" (click)="$event.stopPropagation()">
    <div class="dropdown-search multi-select-search" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
      <tidy-image [src]="'assets/svg/search.svg'" class="search-icon" />
      <input
        #searchInput
        type="text"
        class="search-input"
        [placeholder]="'Search tasks' | translate"
        [value]="searchValue"
        (input)="onSearchInput($event)"
        (click)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
      />
      <button class="clear-button" [class.hidden]="!searchValue" (click)="clearSearch(); $event.stopPropagation()" (mousedown)="$event.stopPropagation()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  @for (task of filteredTasks; track task) {
    <div class="task-dropdown-item" (click)="toggleTask(task); $event.stopPropagation()">
      <div class="task-dropdown-checkbox" [class.checked]="task?.checked"></div>
      <span class="task-dropdown-item-text">{{ task.title }}</span>
    </div>
  }
  @if (filteredTasks && !filteredTasks?.length && tasksService.allTasks?.length) {
    <div class="task-dropdown-empty">
      <i>No tasks match your search</i>
    </div>
  }
  @if (tasksService.allTasks && !tasksService.allTasks?.length) {
    <div class="task-dropdown-empty">
      <i>No tasks for this property</i>
    </div>
  }
  <div class="task-dropdown-divider"></div>
  <div class="task-dropdown-item task-dropdown-add" (click)="goToAddTask()">
    <tidy-image [src]="'assets/svg/add-circle-outline.svg'" class="task-dropdown-add-icon" />
    <span class="task-dropdown-item-text">Add New Task</span>
  </div>
</mat-menu>
